
import Vue from 'vue';
import {Component, Model, Prop} from 'vue-property-decorator';

@Component
export default class AppTextInput
    extends Vue {
    @Model('change') value!: string;
    @Prop() label!: string;
    @Prop() name!: string;
    @Prop() placeholder!: string;
    @Prop() disabled!: boolean;
    @Prop({default: 'off'}) autocomplete!: string;
    @Prop({default: null}) error!: string | null;
    @Prop({default: 'text'}) inputType!: string;
    @Prop() helpText!: null | string;
    @Prop() inputMode!: null | string;

    active: boolean = false;

    get empty() {
        return !this.value;
    }

    onBlur() {
        this.active = false;
        this.$emit('blur');
    }

    get model () {
        return this.value;
    }

    set model(value) {
        this.$emit('change', value)
    }
}
